import { v4 as uuidv4 } from "uuid";

export const getNewItem = type => ({
  id: "new",
  name: "",
  parentId: type === "borrowerDocuments" ? "8d6a8cc4-ac41-11eb-a6e5-00ffdc22d1cc" : "27d8564c-ac43-11eb-a6e5-00ffdc22d1cc",
  sortOrder: 0,
  isActive: true,
  value: "",
  systemActionId: uuidv4(),
  systemAction: null
});

export const getModalTitle = (verb, type) => `${verb} a Document for ${type === "borrowerDocuments" ? "Borrower" : "Guarantor"} Reporting`;
